<div class="sidebar d-flex flex-column min-vh-100" [class.collapsed]="sharedService.isToggleSidebar">
  <!-- Sidebar Toggle -->
  <div class="sidebar-toggle-tab" (click)="toggleSidebar($event)" title="Toggle menu">
    <i class="fa fa-bars"></i>
  </div>
  <!-- Sidebar Top -->
  <div class="sidebar-top d-flex flex-column">
    <div class="sidebar-header p-3 d-flex align-items-center justify-content-between">
      <div class="logo d-flex align-items-center">
        <img
          *ngIf="!sharedService.isToggleSidebar"
          src="assets/images/vault_new_logo.svg"
          alt="Full Logo"
          class="logo-full"
        />
        <img
          *ngIf="sharedService.isToggleSidebar"
          src="assets/images/vault_new_logo_notext.svg"
          alt="Icon Logo"
          class="logo-icon"
        />
      </div>
      <button class="btn toggle-btn" (click)="toggleSidebar($event)" title="{{ sharedService.isToggleSidebar ? 'Expand menu' : 'Collapse menu' }}">
        <i class="fa" [ngClass]="sharedService.isToggleSidebar ? 'fa-arrow-right' : 'fa-arrow-left'"></i>
      </button>
    </div>
  </div>
  <!-- Menu -->
  <div class="sidebar-menu-wrapper flex-grow-1 d-flex flex-column">
    <ul class="nav sidebar-menu flex-column px-2">
      <li class="nav-item my-1">
        <a [routerLink]="['/isbninventory']" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" class="nav-link text-white" title="ISBN Inventory" *ngIf="isLinkVisible('isbn')">
          <i class="fa fa-barcode"></i>
          <span class="ms-2" *ngIf="!sharedService.isToggleSidebar">ISBN Inventory</span>
        </a>
      </li>
      <li class="nav-item my-1">
        <a [routerLink]="['/product']" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" class="nav-link text-white" title="Title Manager" *ngIf="isLinkVisible('product')">
          <i class="fa fa-rectangle-list"></i>
          <span class="ms-2" *ngIf="!sharedService.isToggleSidebar">Title Manager</span>
        </a>
      </li>
      <li class="nav-item my-1">
        <a [routerLink]="['/production']" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" class="nav-link text-white" title="Production" *ngIf="isLinkVisible('production')">
          <i class="fa fa-print"></i>
          <span class="ms-2" *ngIf="!sharedService.isToggleSidebar">Production</span>
        </a>
      </li>
      <li class="nav-item my-1">
        <a [routerLink]="['/author']" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" class="nav-link text-white" title="Business Partner" *ngIf="isLinkVisible('author')">
          <i class="fa fa-users"></i>
          <span class="ms-2" *ngIf="!sharedService.isToggleSidebar">Business Partner</span>
        </a>
      </li>
      <li class="nav-item my-1">
        <a [routerLink]="['/datafeed/channel']" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" class="nav-link text-white" title="Data Feeds" *ngIf="isLinkVisible('datafeeds')">
          <i class="fa fa-feed"></i>
          <span class="ms-2" *ngIf="!sharedService.isToggleSidebar">Data Feeds</span>
        </a>
      </li>
	  <li class="nav-item my-1" *ngIf="isLinkVisible('reports')">
  <a [routerLink]="['/reports']"
     routerLinkActive="active"
     [routerLinkActiveOptions]="{ exact: true }"
     class="nav-link text-white"
     title="Reports">
    <i class="fa fa-chart-bar"></i>
    <span class="ms-2" *ngIf="!sharedService.isToggleSidebar">Reports</span>
  </a>
</li>
<li hidden="true" class="nav-item my-1" *ngIf="isLinkVisible('reports')">
  <a [routerLink]="['/reports-advanced']"
     routerLinkActive="active"
     [routerLinkActiveOptions]="{ exact: true }"
     class="nav-link text-white"
     title="Reports Advanced">
    <i class="fa fa-chart-line"></i>
    <span class="ms-2" *ngIf="!sharedService.isToggleSidebar">Reports Advanced</span>
  </a>
</li>

      <li class="nav-item my-1">
        <a [routerLink]="['/iprights']" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" class="nav-link text-white" title="IP Rights" *ngIf="isLinkVisible('royalty')">
          <i class="fa fa-shield-halved"></i>
          <span class="ms-2" *ngIf="!sharedService.isToggleSidebar">IP Rights</span>
        </a>
      </li>
      <li class="nav-item my-1">
        <a [routerLink]="['/templates']" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" class="nav-link text-white" title="Templates" *ngIf="isLinkVisible('template')">
          <i class="fa fa-file-text"></i>
          <span class="ms-2" *ngIf="!sharedService.isToggleSidebar">Templates</span>
        </a>
      </li>
      <li class="nav-item my-1">
        <a [routerLink]="['/admin']" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" class="nav-link text-white" title="Admin" *ngIf="isLinkVisible('admin')">
          <i class="fa fa-user-cog"></i>
          <span class="ms-2" *ngIf="!sharedService.isToggleSidebar">Admin</span>
        </a>
      </li>
    </ul>
  </div>
</div>